const isObject = (value) => typeof value === "object" && value !== null;

export { isObject };
//# sourceMappingURL=is-object.mjs.map
